import { GTMEventPayload } from '~/actions/gtm.actions';

// eslint-disable-next-line @typescript-eslint/ban-types
function getDataLayer(): object[] {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (<any>window)[CONFIG.gtm.dataLayer] || [];
}

function sendGTMEvent(payload: GTMEventPayload) {
  const gtmDataLayer = getDataLayer();

  gtmDataLayer.push({
    event: payload.eventName,
    ...payload.data,
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types
function pushToGTMDataLayer(payload: object) {
  const gtmDataLayer = getDataLayer();

  gtmDataLayer.push(payload);
}

export { sendGTMEvent, pushToGTMDataLayer };
